import { ExpenseDetailsFormModel_PL, ExpenseGroupType } from './formModel';

const expenseGroupInitialValue: ExpenseGroupType = [
  {
    payment: 0,
    sole: null,
  },
];

export const getInitialValues = (): ExpenseDetailsFormModel_PL => {
  return {
    personalLoan: expenseGroupInitialValue,
    carFinance: expenseGroupInitialValue,
    creditCards: expenseGroupInitialValue,
    otherDebt: expenseGroupInitialValue,
    otherCommitments: expenseGroupInitialValue,
    mortgage: expenseGroupInitialValue,
    total: 0,
  };
};
